import React from 'react';
import { createNativeStackNavigator } from '@react-navigation/native-stack';

import type { SpendStackParamList } from '../../../core/navigation/types';
import { SpendHomeScreen } from '../screens/spend/SpendHomeScreen';
import { TransactionListScreen } from '../screens/spend/TransactionListScreen';

const Stack = createNativeStackNavigator<SpendStackParamList>();

export function SpendStack() {
  return (
    <Stack.Navigator
      initialRouteName="SpendHome"
      screenOptions={{ headerShown: false, animation: 'slide_from_right' }}
    >
      <Stack.Screen name="SpendHome" component={SpendHomeScreen} />
      <Stack.Screen name="TransactionList" component={TransactionListScreen} />
    </Stack.Navigator>
  );
}
